module.exports = __webpack_public_path__ + "media/images/icon/bedroom-7644293522413f928bb1519b8df695d2.svg";